module.exports = __webpack_public_path__ + "img/icon-notification.e5842e6d.svg";